import { render, staticRenderFns } from "./sendMessageDialog.vue?vue&type=template&id=52fb34ba&scoped=true"
import script from "./sendMessageDialog.vue?vue&type=script&lang=js"
export * from "./sendMessageDialog.vue?vue&type=script&lang=js"
import style0 from "./sendMessageDialog.vue?vue&type=style&index=0&id=52fb34ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fb34ba",
  null
  
)

export default component.exports